/*
 * Copyright (c) 2023. Haodong JU
 */

import { StripePayment } from '@/model/firebase/google-fire-base'
import { getProducts } from 'firestore-stripe-payments-jhd'
import { Remember } from '@/model/global/GlobalSettings'
import { groupBy } from 'lodash'

export async function loadProducts (toBuy = 0) {
  const colorArr = [
    '#feede7', '#d8fbfe', '#e3f6ee', '#e1e7fe', '#ebcfb2', '#64b6ac', '#cdfdfc', '#c9e28d', '#b7aca2', '#83c5bd',
    '#a5978b', '#ffadad', '#fdffb6', '#a0c4ff', '#bdb2ff', '#ffc6ff'
  ]
  const products = await getProducts(StripePayment, {
    includePrices: true,
    activeOnly: true
  })
  let item = []
  const langProducts = groupBy(products, it => it.metadata.lang)
  if (toBuy === 1) {
    item = langProducts.en
  } else {
    item = langProducts[Remember.locale] ?? langProducts.de
  }
  return item.map((p, index) => {
    p.prices = p.prices.filter(x => x.active === true)
    if (p.prices[0].type !== 'one_time') {
      p.realPrice = p.prices.find(it => it.interval === 'year') ?? p.prices.find(it => it.interval === 'month')
    } else {
      p.realPrice = p.prices[0]
    }
    p.color = colorArr[index % colorArr.length]
    return p
  })
}

export const ProductCodes = {
  base: 'base',
  tse: 'tse',
  restaurant: 'restaurant',
  advanceSales: 'advanceSales',
  staffManagement: 'staffManagement',
  sales: 'sales',
  cashbook: 'cashbook',
  boss: 'boss',
  reservation: 'reservation',
  saleAnalysis: 'saleAnalysis',
  inventory: 'inventory',
  cashmanage: 'cashmanage',
  takeawayWeb: 'takeawayWeb',
  scanToOrder: 'scanToOrder',
  queneNumber: 'queneNumber',
  kitchenMonitor: 'kitchenMonitor',
  hotpotSystem: 'hotpotSystem',
  lcMobile: 'lcMobile',
  lcPad: 'lcPad',
  sWebsite: 'sWebsite',
  sApp: 'sApp',
  sPrinterSetting: 'sPrinterSetting',
  sProService: 'sProService',
  sGoodService: 'sGoodService',
  hd5: 'hd5',
  hsunmi: 'hsunmi',
  hCard: 'hCard',
  hCashBox: 'hCashBox',
  sSamsung: 'sSamsung',
  sEpsonTmT30: 'sEpsonTmT30',
  oldDevice: 'oldDevice',
  openDevice: 'openDevice',
  webService: 'webService',
  extraStore: 'extraStore',
  hStickerPrinter: 'hStickerPrinter',
  hWifiPrinter: 'hWifiPrinter',
  hPhone: 'hPhone'
}
